import { Button, FormControl, IconButton, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import React, { Component } from 'react';
import Global from "../../customlib/Global";
import Api from "../../customlib/Api";
import axios from "axios";
import { Chat, Update } from '@mui/icons-material';

class DatabaseUnpaid extends Component {
    state = { 
        listCustomerWajibBayar: []
    }
    
    handleUpdateChangedCustomer = (customer, label, reminderKe) => {
        // const customerClone = {...customer};
        const changedList = [...this.state.listCustomerWajibBayar];
        let findExisting = changedList.find(item => item.from === customer.from);

        if(findExisting){
            if(label){
                findExisting.label = label;
                findExisting.contact.contactLabel = label;
            }

            if(reminderKe){
                findExisting.wajibBayarReminderKe = reminderKe;
                findExisting.contact.wajibBayarReminderKe = reminderKe;
            }
            findExisting.changed = true;
        }else{
            if(label){
                customer.label = label;
                customer.contact.contactLabel = label;
            }

            if(reminderKe){
                customer.wajibBayarReminderKe = reminderKe;
                customer.contact.wajibBayarReminderKe = reminderKe;
            }
            customer.changed = true;
            changedList.push(customer);
        }

        this.setState({listCustomerWajibBayar: changedList}, () => {
            console.log("WAJIB_CHANGED_LIST", this.state.listCustomerWajibBayar);
        });

    }

    handleSubmitUpdate = (customer) => {
        console.log("WAJIB_SUBMIT", customer);
        const params = {
            contactNumber: customer.from,
            label: customer.label,
            wajibBayarReminderKe: customer.wajibBayarReminderKe
        };
    
        console.log("PARAMWAJIBBAYAR", params);
    
        axios
            .post(Api.updateWajibBayarStatus(), params, Api.getRequestHeader())
            .then((response) => {
                console.log("WAJIB_UPDATE : ", response.data);
                let data = response.data.data;
                
            if(data){
                const listWajibBayar = [...this.state.listCustomerWajibBayar];
                let filteredWajibBayar = listWajibBayar.filter(item => item.from !== customer.from);
                this.setState({listCustomerWajibBayar: filteredWajibBayar});
            }
        })
        .catch((error) => {
            console.error("There was an error!", error);
        });
    }

    getListCustomerWajibBayar = () => {
    
        const params = {
          appProfileId: Global.getAppProfile()._id,
          userId: Global.get().user.id
        };
    
        console.log("PARAMWAJIBBAYAR", params);
    
        axios
          .post(Api.listCustomerWajibBayar(), params, Api.getRequestHeader())
          .then((response) => {
            console.log("LISTWAJIBBAYAR : ", response.data);
            let data = response.data.data;
    
            let newUnfinished = data.map((result) => {
              result.contact = {
                photo: "https://picsum.photos/seed/picsum/200",
                fromName: result.fromName,
                text: result.lastMessage,
                fromNumber: result.from,
                contactId: result.id,
                toNumber: result.to,
                toName: result.toName,
                selected: false,
                unreadCounter: result.unreadCounter,
                assignToUserName: result.assignToUserName,
                csHelpState: result.csHelpState,
                csId: result.csId,
                csName: result.csName,
                csArchived: result.csArchived,
                contactLabel: result.label,
                deliveryDate: result.deliveryDate,
                productCategory: result.productCategory,
                cityName: result.cityName,
                keterangan: result.keterangan,
                emailRegister: result.emailRegister
              };
              return result;
            })
    
            this.setState({listCustomerWajibBayar: newUnfinished});
          })
          .catch((error) => {
            console.error("There was an error!", error);
          });
      };

    componentDidMount() {
        this.getListCustomerWajibBayar();
    }

    render() { 
        return (
            <TableContainer>
                <Table aria-label="sticky table">
                    <TableHead>
                        {/* <TableRow> */}
                        <TableCell key="nama" align="left" style={{ minWidth: "30px" }} >
                            <strong>No</strong>
                        </TableCell>
                        <TableCell key="nama" align="left" style={{ minWidth: 100 }} >
                            <strong>Nama Customer</strong>
                        </TableCell>
                        <TableCell key="kategori" align="left" style={{ minWidth: 100 }} >
                            <strong>Jenis Produk</strong>
                        </TableCell>
                        <TableCell key="Kota" align="left" style={{ minWidth: 100 }} >
                            <strong>Kota Pengiriman</strong>
                        </TableCell>
                        <TableCell key="tanggal" align="left" style={{ minWidth: 100 }} >
                            <strong>Tanggal Leads</strong>
                        </TableCell>
                        <TableCell key="tanggal-kirim" align="left" style={{ minWidth: 100 }} >
                            <strong>Estimasi Tanggal Kirim</strong>
                        </TableCell>
                        <TableCell key="reminder-ke" align="left" style={{ minWidth: 100 }} >
                            <strong>Reminder Ke</strong>
                        </TableCell>
                        <TableCell key="pic-fu" align="left" style={{ minWidth: 100 }} >
                            <strong>PIC Fu</strong>
                        </TableCell>
                        <TableCell key="update-label" align="left" style={{ minWidth: 100 }} >
                            <strong>Update Label</strong>
                        </TableCell>
                        <TableCell key="action" align="left" style={{ minWidth: 100 }} >
                            <strong>Action</strong>
                        </TableCell>
                        {/* </TableRow> */}
                    </TableHead>
                    <TableBody>
                        {this.state.listCustomerWajibBayar.map((row, index) => {
                        return (
                            <TableRow>
                                <TableCell>{index+1}</TableCell>
                                <TableCell>{row.contact.fromName}</TableCell>
                                <TableCell>{row.contact.productCategory}</TableCell>
                                <TableCell>{row.contact.cityName}</TableCell>
                                <TableCell>{row.contact.created_at !== null && row.created_at !== undefined ? Global.formatDateTimeToStrDateTime24(row.created_at) : ""}</TableCell>
                                <TableCell>{row.contact.deliveryDate !== null && row.deliveryDate !== undefined ? Global.formatDateTimeToStrDateTime24(row.deliveryDate) : ""}</TableCell>
                                <TableCell>
                                    <Select
                                        size='small'
                                        id={`reminder-ke-${row._id}`}
                                        value={row.wajibBayarReminderKe ?? 0}
                                        onChange={(event) => {
                                            this.handleUpdateChangedCustomer(row, null, event.target.value);
                                        }}
                                    >
                                        <MenuItem value={0}>0</MenuItem>
                                        <MenuItem value={1}>1</MenuItem>
                                        <MenuItem value={2}>2</MenuItem>
                                        <MenuItem value={3}>3</MenuItem>
                                    </Select>
                                </TableCell>
                                <TableCell>{row.contact.assignToUserName}</TableCell>
                                <TableCell>
                                    <Select
                                        size='small'
                                        id={`label-${row._id}`}
                                        value={row.label ?? ""}
                                        label="Age"
                                        onChange={(event) => {
                                            this.handleUpdateChangedCustomer(row, event.target.value, null);
                                        }}
                                    >
                                        <MenuItem value={"UNPAID"}>UNPAID</MenuItem>
                                        <MenuItem value={"CANCEL"}>CANCEL</MenuItem>
                                    </Select>
                                </TableCell>
                                <TableCell>

                                    {
                                        row.changed === true && (
                                            <Tooltip title={"Submit Update"}>
                                                <IconButton color='warning' onClick={(event) => {
                                                    this.handleSubmitUpdate(row);
                                                }}>
                                                    <Update />
                                                </IconButton>
                                            </Tooltip>
                                        )
                                    }

                                    <Tooltip title={"Chat Sekarang"}>
                                        <IconButton color='success' onClick={() => {
                                        let windowReference = window.open();
                                        var url = 'https://api.whatsapp.com/send?phone=' 
                                                + row.contact.fromNumber 
                                                + '&text=' 
                                                + encodeURIComponent("")

                                            windowReference.location = url;
                                        }}>
                                            <Chat />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }
}
 
export default DatabaseUnpaid;